import React, { Fragment, useEffect, useState } from "react";
import "./home.scss";
import Header from "../../components/header";

import Card from "../../components/card";
import AtresPieChart from "../../components/charts/atresPieChart";
import AtresBarChart from "../../components/charts/atresBarChart";

import TableCompare from "../../components/table";
import Tag from "../../components/tag";
import Tags from "../../components/tags";
import Button from "../../components/button";
import PactometroCheckSimple from "../../components/pactometroCheck/pactometroCheckSimple";
import {
  PlacesProvider,
  getPlace,
  getExcludes
} from "../../dataProvider/places";
import CustomMap from "../../components/homeMap/customMap";

import ElTabs from "../../components/elTabs";
import { TYPES, SUBTYPES } from "../../envs/core";
import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import Autocomplete from "../../components/autocomplete/index";
import { getTitle, getRoute, navigateTo } from "../../utils/index";
import { getData } from "../../dataProvider/places/single";

const Chart =
  window.location.hostname
    .replace("localhost", "lasexta")
    .indexOf("lasexta") === -1
    ? AtresPieChart
    : AtresBarChart;

const PactosTxt =
  window.location.hostname
    .replace("localhost", "lasexta")
    .indexOf("lasexta") === -1
    ? "Pactos"
    : "Pactómetro";

const InfoTxt =
  window.location.hostname
    .replace("localhost", "lasexta")
    .indexOf("lasexta") === -1
    ? "10N"
    : "DATOS";

const addRoute = (data, place, community, excludes) => {
  return data.map(town => {
    const route = getRoute(town, community, excludes);
    return { ...town, href: route };
  });
};

const Home = ({ match, history }) => {
  const {
    year,
    type,
    electionNumber,
    community,
    province,
    reload,
    placesIds
  } = match.params;

  const [title, setTitle] = useState(getTitle(type, year));
  const [allRegions, setAllRegions] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [mapData, setMapData] = useState([]);

  const [elSubtype, setElSubtype] = useState(
    type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
  );
  const [autocomple, setAutocomple] = useState("");
  const [communities, setCommunities] = useState([]);
  const [autocomplePro, setAutocomplePro] = useState("");
  const [excludes, setExcludes] = useState(null);

  const [resultOrigin, setResultOrigin] = useState({});
  const [lastYear, setLastYear] = useState();

  const tabsTitle =
    (type === TYPES.GENERAL && elSubtype === SUBTYPES.CONGRESS) ||
    type === TYPES.REGIONAL
      ? resultOrigin.primary &&
        resultOrigin.primary.year === 2019 &&
        resultOrigin.primary.numElection === 2
        ? [InfoTxt, "28A", lastYear, PactosTxt]
        : [InfoTxt, lastYear, PactosTxt]
      : [InfoTxt];

  // Hide label when we are at top level
  const showSelectedPlace = selectedPlace.ineId !== placesIds;

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
        //Adhoc por que en 2019 hubo 2 elecciones en el mismo año y se queria mostrar también los datos de 2016
        historicResult.primary.year === 2019 &&
        historicResult.primary.numElection === 2
          ? setLastYear("2016")
          : setLastYear(String(historicResult.historic.year));
      })
      .catch(err => {});

    getData(placesIds).then(place => {
      setTitle(getTitle(type, year, place.name));
    });

    if (type === TYPES.GENERAL) {
      getPlace("typeplace=REGION&parentid=C108&size=1000").then(regions => {
        setAllRegions(regions.content);
      });
    }
  }, [year, type, electionNumber, placesIds]);

  useEffect(() => {
    getData(
      type === TYPES.REGIONAL
        ? province || placesIds
        : province || community || placesIds
    ).then(place => {
      setSelectedPlace(place);
    });
  }, [community, province]);

  useEffect(() => {
    Promise.all([
      getPlace(`sortby=main&size=60`),
      getPlace(`typeplace=PROVINCE&size=60`),
      getPlace(`typeplace=REGION&size=60`),

      getExcludes()
    ]).then(([data, places, _communities, _excludes]) => {
      const placesWithRoute = addRoute(
        places.content,
        data.content,
        community,
        _excludes
      );
      setCommunities(
        _communities.content.map(i => ({ ...i, parentId: i.ineId }))
      );
      setMapData(placesWithRoute);
      setExcludes(_excludes);
    });
  }, []);

  const goToDetails = (child, event) => {
    if (!Boolean(parseInt(reload))) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      navigateTo(
        history,
        reload,
        `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${child.parentId}/${child.ineId}/detalle.html`,
        child,
        community,
        excludes
      );
    }
  };

  const changeMapSelection = (parent, child, fromMap, event) => {
    if (event && !Boolean(parseInt(reload))) {
      event.preventDefault();
      event.stopPropagation();

      if (community && child && child.ineId !== parent) {
        navigateTo(
          history,
          reload,
          `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${child.parentId}/${child.ineId}/resultados.html`,
          child,
          !fromMap || community,
          excludes
        );
      } else if (parent && community !== parent) {
        navigateTo(
          history,
          reload,
          `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${parent}/resultados.html`,
          child,
          !fromMap || community,
          excludes
        );
      }
    }
  };

  const changeSubType = subtype => {
    setElSubtype(subtype);
  };

  return (
    <Fragment>
      <div className="mainWrapper pageHome">
        <Header>
          <h2>
            <span className="featured">10-N</span> {title}
          </h2>
        </Header>
        {resultOrigin && resultOrigin.primary ? (
          <ResultProvider
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={elSubtype}
            electionPlace={placesIds}
            electionNumber={electionNumber}
            placeId={province || community}
          >
            {dataResult => (
              <div className="colContainer">
                <div className="floatingBlock left">
                  <div className="inner">
                    <div className="mapSelectorContainer">
                      {type === TYPES.GENERAL && (
                        <div className="buttonsContainer">
                          <Fragment>
                            <Button
                              className={
                                elSubtype === SUBTYPES.CONGRESS ? "current" : ""
                              }
                              onClick={() => changeSubType(SUBTYPES.CONGRESS)}
                            >
                              Congreso
                            </Button>
                            <Button
                              className={
                                elSubtype === SUBTYPES.SENATE ? "current" : ""
                              }
                              onClick={() => changeSubType(SUBTYPES.SENATE)}
                            >
                              Senado
                            </Button>
                          </Fragment>
                        </div>
                      )}
                      <div className="mapContainer">
                        <Fragment>
                          <h2 className="selectedPlaceTitle">
                            <span className="selectedTownTitle">
                              {showSelectedPlace && selectedPlace.name}
                            </span>
                            <PlacesProvider
                              name={autocomple}
                              type="PROVINCE"
                              parentId={community}
                            >
                              {data => {
                                return (
                                  <Autocomplete
                                    results={[
                                      ...data,
                                      ...communities.filter(d => {
                                        return autocomple
                                          ? d.name
                                              .toLocaleLowerCase()
                                              .includes(
                                                autocomple.toLocaleLowerCase()
                                              )
                                          : true;
                                      })
                                    ]}
                                    onChange={value => setAutocomple(value)}
                                    onSelect={select => {
                                      select.typePlace === "REGION"
                                        ? navigateTo(
                                            history,
                                            reload,
                                            `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${select.ineId}/resultados.html`,
                                            select,
                                            false,
                                            excludes
                                          )
                                        : navigateTo(
                                            history,
                                            reload,
                                            `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${select.parentId}/${select.ineId}/resultados.html`,
                                            select,
                                            true,
                                            excludes
                                          );
                                      setAutocomple("");
                                    }}
                                    placeholder={"Busque comunidad o provincia"}
                                    showArrow
                                  />
                                );
                              }}
                            </PlacesProvider>
                          </h2>
                          <CustomMap
                            allRegions={allRegions}
                            selectedPlace={selectedPlace}
                            partiesWinners={dataResult.partiesWinners || []}
                            native={true}
                            maps={mapData}
                            isRegional={type === TYPES.REGIONAL}
                            isFiltered={
                              type !== TYPES.REGIONAL
                                ? Boolean(community)
                                : Boolean(province)
                            }
                            currentCommunity={community}
                            onChange={changeMapSelection}
                          />
                          {community && (
                            <p className="buttonBackContainer">
                              <a
                                href={
                                  (excludes && excludes["C108"]) ||
                                  "https://www.ondacero.es/noticias/elecciones-generales/resultados/2019-espana-10n-C108"
                                }
                                type="button"
                                className="tag button current"
                                onClick={e => {
                                  if (!Boolean(parseInt(reload))) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    navigateTo(
                                      history,
                                      reload,
                                      `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/resultados.html`
                                    );
                                  }
                                }}
                              >
                                Volver
                          </a>
                            </p>
                          )}
                        </Fragment>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="floatingBlock right">
                  <div className="inner">
                    <Card
                      title="ESCRUTADO:"
                      titleValue={`${
                        !isNaN(Number(dataResult.currentCountPercent))
                          ? Number(
                              dataResult.currentCountPercent
                            ).toLocaleString()
                          : "0"
                      }%`}
                      subtitle={`Actualizado a las: ${
                        dataResult.updateDate
                          ? dataResult.updateDate.slice(0, -3)
                          : "00:00"
                      }`}
                      className="graphContainer"
                    >
                      <Chart
                        data={dataResult.partiesResult || []}
                        dataKey="seats"
                        isSenate={elSubtype === SUBTYPES.SENATE}
                        showLabel={
                          type !== TYPES.REGIONAL
                            ? !province && !community
                            : !Boolean(province)
                        }
                        seatTotal={dataResult.totalSeats || 0}
                      />
                      {community && (
                        <p className="buttonBackContainer">
                          <a
                            href={
                              (excludes && excludes["C108"]) ||
                              "https://www.ondacero.es/noticias/elecciones-generales/resultados/2019-espana-10n-C108"
                            }
                            type="button"
                            className="tag button current"
                            onClick={e => {
                              if (!Boolean(parseInt(reload))) {
                                e.preventDefault();
                                e.stopPropagation();
                                navigateTo(
                                  history,
                                  reload,
                                  `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/resultados.html`
                                );
                              }
                            }}
                          >
                            Volver
                          </a>
                        </p>
                      )}
                    </Card>
                  </div>
                </div>

                <div className="floatingBlock right">
                  <div className="inner">
                    <ElTabs titles={tabsTitle}>
                      <TableCompare
                        className="current"
                        data={dataResult.partiesResult || []}
                        details={
                          elSubtype === SUBTYPES.CONGRESS ||
                          type === TYPES.REGIONAL
                        }
                        isSenate={elSubtype === SUBTYPES.SENATE}
                        legend={
                          type === TYPES.GENERAL && [
                            "*Unidas Podemos: Podemos, IU, En Comú Podem y En Común-Unidas Podemos​",
                            "Más País: Más País, Més Compromís, Más País EQUO,  M País-CHA-EQUO"
                          ]
                        }
                      />
                      <div>
                        <ResultProvider
                          active={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.active
                          }
                          year={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.year
                          }
                          type={type}
                          subtype={elSubtype}
                          electionPlace={placesIds}
                          electionNumber={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.numElection
                          }
                          placeId={province || community}
                        >
                          {oldData => (
                            <Chart
                              data={oldData.partiesResult || []}
                              dataKey="seats"
                              isSenate={elSubtype === SUBTYPES.SENATE}
                              showLabel={
                                type !== TYPES.REGIONAL
                                  ? !province && !community
                                  : !Boolean(province)
                              }
                              seatTotal={oldData.totalSeats || 0}
                            />
                          )}
                        </ResultProvider>
                      </div>
                      {resultOrigin.primary.year === 2019 &&
                      resultOrigin.primary.numElection === 2 ? (
                        <div>
                          <ResultProvider
                            active={
                              resultOrigin &&
                              resultOrigin.historic &&
                              resultOrigin.historic.active
                            }
                            year={lastYear}
                            type={type}
                            subtype={elSubtype}
                            electionPlace={placesIds}
                            electionNumber={
                              resultOrigin &&
                              resultOrigin.historic &&
                              resultOrigin.historic.numElection
                            }
                            placeId={province || community}
                          >
                            {oldData => (
                              <Chart
                                data={oldData.partiesResult || []}
                                dataKey="seats"
                                isSenate={elSubtype === SUBTYPES.SENATE}
                                showLabel={
                                  type !== TYPES.REGIONAL
                                    ? !province && !community
                                    : !Boolean(province)
                                }
                                seatTotal={oldData.totalSeats || 0}
                              />
                            )}
                          </ResultProvider>
                        </div>
                      ) : (
                        <div className="pactometroWrapper">
                          <ResultProvider
                            active={
                              resultOrigin &&
                              resultOrigin.primary &&
                              resultOrigin.primary.active
                            }
                            year={
                              resultOrigin &&
                              resultOrigin.primary &&
                              resultOrigin.primary.year
                            }
                            type={type}
                            placeId={placesIds}
                            subtype={
                              type === TYPES.GENERAL
                                ? SUBTYPES.CONGRESS
                                : SUBTYPES.SINGLE
                            }
                            electionPlace={placesIds}
                            electionNumber={electionNumber}
                          >
                            {generalData => (
                              <div className="pactometroScroll">
                                <PactometroCheckSimple
                                  totalSeat={generalData.totalSeats}
                                  seatData={generalData.partiesResult || []}
                                />
                              </div>
                            )}
                          </ResultProvider>
                        </div>
                      )}
                      {resultOrigin.primary.year === 2019 &&
                        resultOrigin.primary.numElection === 2 && (
                          <div className="pactometroWrapper">
                            <ResultProvider
                              active={
                                resultOrigin &&
                                resultOrigin.primary &&
                                resultOrigin.primary.active
                              }
                              year={
                                resultOrigin &&
                                resultOrigin.primary &&
                                resultOrigin.primary.year
                              }
                              type={type}
                              placeId={placesIds}
                              subtype={
                                type === TYPES.GENERAL
                                  ? SUBTYPES.CONGRESS
                                  : SUBTYPES.SINGLE
                              }
                              electionPlace={placesIds}
                              electionNumber={electionNumber}
                            >
                              {generalData => (
                                <div className="pactometroScroll">
                                  <PactometroCheckSimple
                                    totalSeat={generalData.totalSeats}
                                    seatData={generalData.partiesResult || []}
                                  />
                                </div>
                              )}
                            </ResultProvider>
                          </div>
                        )}
                    </ElTabs>
                  </div>
                </div>

                <div className="floatingBlock left">
                  <div className="inner">
                    <Card
                      title="Principales ciudades de"
                      titleValue={selectedPlace.name}
                    >
                      <div className="selectsContainer CityTagsselectsContainer">
                        <PlacesProvider
                          name={autocomplePro}
                          type="TOWN"
                          parentId={province}
                        >
                          {data => {
                            return (
                              <Autocomplete
                                results={data}
                                onChange={value => setAutocomplePro(value)}
                                onSelect={select => {
                                  navigateTo(
                                    history,
                                    reload,
                                    `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${select.parentId}/${select.ineId}/detalle.html`,
                                    select,
                                    true,
                                    excludes
                                  );
                                }}
                                placeholder={"Busque municipio"}
                                showArrow
                              />
                            );
                          }}
                        </PlacesProvider>
                      </div>
                      <Tags>
                        <PlacesProvider
                          type="TOWN"
                          grandParentId={!province ? community : null}
                          parentId={province || community}
                          size={10}
                          sortby="main"
                        >
                          {data =>
                            data &&
                            data.slice(0, 10).map(d => (
                              <Tag
                                key={`${d.ineId}-${d.name}`}
                                onClick={e => {
                                  goToDetails(d, e);
                                }}
                                native
                                route={getRoute(d, true, excludes)}
                              >
                                {d.name}
                              </Tag>
                            ))
                          }
                        </PlacesProvider>
                      </Tags>
                    </Card>
                  </div>
                </div>
              </div>
            )}
          </ResultProvider>
        ) : (
          <div>Loading</div>
        )}
      </div>
    </Fragment>
  );
};

export default Home;
